import {
  Box,
  Button,
  Grid2,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import { commonCss } from "../../../CssStyle/commonCss";
import { Done } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
// import image2 from "../../../Images/IPB/image2.png";
// import image3 from "../../../Images/IPB/image3.png";
// import image4 from "../../../Images/IPB/image4.png";
// import image5 from "../../../Images/IPB/image5.png";
// import image6 from "../../../Images/IPB/image6.png";

// import dashboard from "../../../Images/EAM/Dashboard.png";
// import formList from "../../../Images/EAM/formlist.png";
// import formPage from "../../../Images/EAM/formpage.png";

// import dashboardPTW from "../../../Images/PTW/dashboard.png";
// import formListPTW from "../../../Images/PTW/formlist.png";
// import formPagePTW from "../../../Images/PTW/formpage.png";

// import dashboardWalk from "../../../Images/safetyWalk/dashboard.png";
// import formListWalk from "../../../Images/safetyWalk/formlist.png";
// import formPageWalk from "../../../Images/safetyWalk/formpage.png";

// import dashboardForm from "../../../Images/e-Form/dashboard.png";
// import formListForm from "../../../Images/e-Form/form.png";
// import suppliers from "../../../Images/e-Form/suppliers.png";

// import dashboardOJT from "../../../Images/OJT/dashboard.png";
// import userTraining from "../../../Images/OJT/userTraining.png";
// import trainerTraining from "../../../Images/OJT/trainerTraining.png";

const CommonPage = () => {
  const navigate=useNavigate()
  const [searchParams,setSearchParams]=useSearchParams()
      // useEffect(() => {
      //     const element = document.getElementById(searchParams.get("productName"));
      //     if (element) {
      //       element.scrollIntoView({behavior: "smooth" });
      //     }
      //   }, [searchParams.get("productName")]);
  return (
    <Grid2 container justifyContent={"center"}>
      <Grid2
        container
        size={12}
        sx={{ mt: { xs: "30%", sm: "25%", md: "20%", lg: "15%", xl: "8%" } }}
      >
        <Grid2  id="eam" container size={12} justifyContent={"center"}>
          <Grid2 container size={12} justifyContent={"center"}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "1rem",
                mt: "1rem",
                alignItems: "center",
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: "2.2rem", md: "2.5rem" },
                  fontWeight: 600,
                  color: commonCss.orange,
                }}
              >
                Our Products
              </Typography>

              <Typography
                variant="h4"
                sx={{
                  textAlign: { xs: "center", md: "left" },
                  fontWeight: 500,
                  color: commonCss.blue,
                  fontSize: { xs: "2rem", md: "2.2rem" },
                  mb: "2.5rem",
                  // textShadow: '0 0 5px rgba(255, 255, 255, 0.8)'
                }}
              >
                Enterprise Asset Management
              </Typography>
            </Box>
          </Grid2>
          <Grid2 container justifyContent={"center"}>
            <Grid2
              container
              size={12}
              spacing={"1rem"}
              sx={{
                padding: { xs: "1.5rem", md: "0 3rem 3rem 3rem" },
                maxWidth: { xs: "auto", xl: "2000px" },
              }}
              alignItems={"center"}
            >
              <Grid2
                container
                size={{ xs: 12, md: 6 }}
                justifyContent={{ xs: "center", md: "flex-start" }}
              >
                {/* <Box sx={{display:'flex',width:"100%",height:"fit-content",alignItems:"center",gap:"1rem"}}>
            <img src={dashboard} style={{width:'60%',height:"50vh",borderRadius:"10px",border:"5px solid #474747"}}/>
            <img src={dashboard_mobile} style={{width:'20%',height:"40vh",borderRadius:"10px",border:"5px solid #474747"}}/>
            </Box> */}
                <img src={"/Images/EAM/Dashboard.png"} alt="EAM dashboard" style={{ width: "85%", height: "100%" }} />
              </Grid2>
              <Grid2
                size={{ xs: 12, md: 6 }}
                sx={{
                  pr: {
                    xs: 0,
                    md: "3rem",
                    fontFamily: "Roboto, Arial, sans-serif",
                  },
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: "35px", md: "40px" },
                    textAlign: { xs: "center", md: "left" },
                    fontWeight: 700,
                    fontFamily: "inherit",
                  }}
                >
                  EAM Web & Mobile App
                </Typography>
                <Typography
                  variant="h1"
                  sx={{
                    letterSpacing: 0.3,
                    lineHeight: 1.5,
                    fontWeight: 300,
                    fontFamily: "inherit",
                    fontSize: "20px",
                    mt: "1rem",
                  }}
                >
                  A{" "}
                  <span style={{ color: commonCss.orange, fontWeight: 600 }}>
                    Enterprise Asset Management (EAM) solution
                  </span>{" "}
                  designed to optimize the management of your organization’s
                  assets throughout their entire lifecycle, from asset
                  acquisition to disposal. EAM empowers you to maximize
                  asset performance, minimize downtime, and drive operational
                  efﬁency across your enterprise. Say goodbye to fragmanted
                  asset management processes and embrace a uniﬁed approach with
                  our cutting-edge EAM Solution.
                </Typography>

                <Typography
                  sx={{
                    fontSize: "1.1rem",
                    fontWeight: 700,
                    fontFamily: "inherit",
                    mt: 4,
                  }}
                >
                  Key Features
                </Typography>
                <List
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontFamily: "Roboto, sans-serif",
                      fontSize: "1rem",
                      fontWeight: 600,
                    },
                    display: "flex",
                    columnGap: "1rem",
                    flexWrap: "wrap",
                    width: "100%",
                    mt: 1,
                  }}
                >
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Assest Management</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Workorder Management</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Inventory Management</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Mobile EAM</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>IIOT Management</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Integration Management</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Health, Safety & Environment (HSE) Management{" "}
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>KPI & Dashboard</ListItemText>
                  </ListItem>
                </List>
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2
            container
            justifyContent={"center"}
            sx={{ background: commonCss.backgroundGray }}
          >
            <Grid2
              container
              size={12}
              spacing={"1rem"}
              sx={{
                padding: { xs: "1.5rem", md: "3rem" },
                maxWidth: { xs: "auto", md: "2000px" },
              }}
              alignItems={"center"}
            >
              <Grid2
                size={{ xs: 12, md: 6 }}
                sx={{
                  pl: {
                    xs: 0,
                    md: "3rem",
                    fontFamily: "Roboto, Arial, sans-serif",
                  },
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: "35px", md: "40px" },
                    fontWeight: 700,
                    fontFamily: "inherit",
                  }}
                >
                  {" "}
                  Transform your assest management practices, drive operational
                  excellence and unlock new levels of efficiency and
                  productivity.
                </Typography>
                <Typography
                  variant="h1"
                  sx={{
                    letterSpacing: 0.3,
                    lineHeight: 1.5,
                    fontWeight: 300,
                    fontFamily: "inherit",
                    fontSize: "20px",
                    mt: "1rem",
                  }}
                >
                  Why Use EAM?
                </Typography>

                {/* <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Key Features</Typography> */}
                <List
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontFamily: "Roboto, sans-serif",
                      fontSize: "1rem",
                      fontWeight: 600,
                    },
                    display: "flex",
                    columnGap: "1rem",
                    flexWrap: "wrap",
                    width: "100%",
                    mt: 4,
                  }}
                >
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Regular maintenance and monitoring reduce wear and tear.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Proactive maintenance minimizes unexpected failures.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Efficient resource management cuts maintenance and
                      operational expenses.
                    </ListItemText>
                  </ListItem>
                </List>
              </Grid2>
              <Grid2
                container
                size={{ xs: 12, md: 6 }}
                justifyContent={{ xs: "center", md: "flex-end" }}
              >
                <img src={"/Images/EAM/formlist.png"} alt="EAM form list" style={{ width: "85%", height: "100%" }} />
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2 container justifyContent={"center"}>
            <Grid2
              container
              size={12}
              spacing={"1rem"}
              sx={{
                padding: { xs: "1.5rem", md: "3rem 3rem 1rem 3rem" },
                maxWidth: { xs: "auto", xl: "2000px" },
              }}
              alignItems={"center"}
            >
              <Grid2
                container
                size={{ xs: 12, md: 6 }}
                justifyContent={{ xs: "center", md: "flex-start" }}
              >
                <img src={"/Images/EAM/formpage.png"} alt="EAM form page" style={{ width: "85%", height: "100%" }} />
              </Grid2>
              <Grid2
                size={{ xs: 12, md: 6 }}
                sx={{
                  pr: {
                    xs: 0,
                    md: "3rem",
                    fontFamily: "Roboto, Arial, sans-serif",
                  },
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: "35px", md: "40px" },
                    fontWeight: 700,
                    fontFamily: "inherit",
                  }}
                >
                  Benefits
                </Typography>
                {/* <Typography variant="h1" sx={{letterSpacing:0.3,lineHeight:1.5,fontWeight:300,fontFamily:"inherit",fontSize:"20px",mt:"1rem"}}>A <span style={{color:commonCss.orange,fontWeight:600}}>Safety Walk</span> is a digital platform designed to streamline safety inspections, audits, and reporting processes in workplaces. It typically helps organizations ensure compliance with safety standards, identify hazards, and promote a safer environment.</Typography>
            
            <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Benefits</Typography> */}
                <List
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontFamily: "Roboto, sans-serif",
                      fontSize: "1.1rem",
                      fontWeight: 400,
                    },
                    display: "flex",
                    columnGap: "1rem",
                    flexWrap: "wrap",
                    width: "100%",
                    mt: 1,
                  }}
                >
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Improved the assest performance.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Reduced downtime.</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Cost savings</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Enhanced decision-making.</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Increased efficiency.</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Improved compliance </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Risk mitigation</ListItemText>
                  </ListItem>
                </List>
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2 size={12} container justifyContent={"flex-end"} sx={{p:"0rem 2rem 2rem 0rem",width:{xs:"auto",xl:"2000px"}}}>
                <Button
                        sx={{
                          backgroundColor: commonCss.buttonBg,
                          color: commonCss.buttonText,
                          padding: "0.5rem 2rem",
                          textTransform: "none",
                          width:"fit-content",
                          fontWeight: 500,
                          fontSize: "0.95rem",
                          borderRadius: "30px",
                          ":hover": {
                            background: commonCss.blue,
                          },
                           position: 'relative',
                            transition: '0.3s',
                              animation: 'glow 1.5s infinite alternate',
                          
                            '@keyframes glow': {
                              '0%': {
                                background: "#FCAE1E",
                              },
                              '100%': {
                                background: commonCss.blue,
                              },
                            },
                        }}
                        onClick={() => {
                          navigate("/contactus?type=Product Demo&&demo=Enterprise Asset Management");
                        }}
                      >
                        Schedule a Demo
                      </Button>
                </Grid2>
        </Grid2>
        <Grid2 id="ibp" container size={12} justifyContent={"center"}>
          <Grid2 container size={12} justifyContent={"center"}>
            <Typography
              variant="h4"
              sx={{
                textAlign: { xs: "center", md: "left" },
                fontWeight: 500,
                color: commonCss.blue,
                fontSize: { xs: "2rem", md: "2.2rem" },
                mb: "2.5rem",
                // textShadow: '0 0 5px rgba(255, 255, 255, 0.8)'
              }}
            >
              Internet Booking Platform
            </Typography>
          </Grid2>
          <Grid2 container justifyContent={"center"}>
            <Grid2
              container
              size={12}
              spacing={"1rem"}
              sx={{
                padding: { xs: "1.5rem", md: "0 3rem 3rem 3rem" },
                maxWidth: { xs: "auto", xl: "2000px" },
              }}
              alignItems={"center"}
            >
              <Grid2
                container
                size={{ xs: 12, md: 6 }}
                justifyContent={{ xs: "center", md: "flex-start" }}
              >
                <img src={"/Images/IPB/image3.png"} alt="Internet Booking Platform screenshot" style={{ width: "85%", height: "100%" }} />
              </Grid2>
              <Grid2
                size={{ xs: 12, md: 6 }}
                sx={{
                  pr: {
                    xs: 0,
                    md: "3rem",
                    fontFamily: "Roboto, Arial, sans-serif",
                  },
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: "35px", md: "40px" },
                    textAlign: { xs: "center", md: "left" },
                    fontWeight: 700,
                    fontFamily: "inherit",
                  }}
                >
                  Internet Booking Platform Web App
                </Typography>
                <Typography
                  variant="h1"
                  sx={{
                    letterSpacing: 0.3,
                    lineHeight: 1.5,
                    fontWeight: 300,
                    fontFamily: "inherit",
                    fontSize: "20px",
                    mt: "1rem",
                  }}
                >
                  A{" "}
                  <span style={{ color: commonCss.orange, fontWeight: 600 }}>
                    Internet Booking Platform{" "}
                  </span>{" "}
                  is a comprehensive online solution designed to simplify the
                  process of booking various services through a unified,
                  user-friendly platform. Whether it’s reserving accommodations,
                  booking appointments, purchasing event tickets, or scheduling
                  services, this platform aims to provide a seamless and
                  efficient experience for users and service providers alike.
                </Typography>

                <Typography
                  sx={{
                    fontSize: "1.1rem",
                    fontWeight: 700,
                    fontFamily: "inherit",
                    mt: 4,
                  }}
                >
                  Key Features
                </Typography>
                <List
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontFamily: "Roboto, sans-serif",
                      fontSize: "1rem",
                      fontWeight: 600,
                    },
                    display: "flex",
                    columnGap: "1rem",
                    flexWrap: "wrap",
                    width: "100%",
                    mt: 1,
                  }}
                >
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>User Management</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText> Service Listings</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Booking and Reservations</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Payment Processing</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Search and Filtering</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Admin and Provider Dashboard</ListItemText>
                  </ListItem>
                </List>
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2
            container
            justifyContent={"center"}
            sx={{ background: commonCss.backgroundGray }}
          >
            <Grid2
              container
              size={12}
              spacing={"1rem"}
              sx={{
                padding: { xs: "1.5rem", md: "3rem" },
                maxWidth: { xs: "auto", md: "2000px" },
              }}
              alignItems={"center"}
            >
              <Grid2
                size={{ xs: 12, md: 6 }}
                sx={{
                  pl: {
                    xs: 0,
                    md: "3rem",
                    fontFamily: "Roboto, Arial, sans-serif",
                  },
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: "35px", md: "40px" },
                    fontWeight: 700,
                    fontFamily: "inherit",
                  }}
                >
                  We use an Internet Booking Platform (IBP) system because it
                  provides a streamlined and efficient way to manage bookings
                  and reservations online
                </Typography>
                <Typography
                  variant="h1"
                  sx={{
                    letterSpacing: 0.3,
                    lineHeight: 1.5,
                    fontWeight: 300,
                    fontFamily: "inherit",
                    fontSize: "20px",
                    mt: "1rem",
                  }}
                >
                  Why Use an IBP?
                </Typography>

                {/* <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Key Features</Typography> */}
                <List
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontFamily: "Roboto, sans-serif",
                      fontSize: "1rem",
                      fontWeight: 600,
                    },
                    display: "flex",
                    columnGap: "1rem",
                    flexWrap: "wrap",
                    width: "100%",
                    mt: 4,
                  }}
                >
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Customers can book anytime from anywhere, increasing
                      convenience and customer satisfaction.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Instantly updates availability and prevents double
                      bookings.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Reduces manual work with automated confirmations,
                      reminders, and payments.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Easy-to-use interfaces and quick booking processes improve
                      user satisfaction.
                    </ListItemText>
                  </ListItem>
                </List>
              </Grid2>
              <Grid2
                container
                size={{ xs: 12, md: 6 }}
                justifyContent={{ xs: "center", md: "flex-end" }}
              >
                <img src={"/Images/IPB/image4.png"} alt="Internet Booking Platform screenshot" style={{ width: "85%", height: "100%" }} />
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2 container justifyContent={"center"}>
            <Grid2
              container
              size={12}
              spacing={"1rem"}
              sx={{
                padding: { xs: "1.5rem", md: "3rem" },
                maxWidth: { xs: "auto", xl: "2000px" },
              }}
              alignItems={"center"}
            >
              <Grid2
                container
                size={{ xs: 12, md: 6 }}
                justifyContent={{ xs: "center", md: "flex-start" }}
              >
                <img src={"/Images/IPB/image5.png"} alt="Internet Booking Platform screenshot" style={{ width: "85%", height: "100%" }} />
              </Grid2>
              <Grid2
                size={{ xs: 12, md: 6 }}
                sx={{
                  pr: {
                    xs: 0,
                    md: "3rem",
                    fontFamily: "Roboto, Arial, sans-serif",
                  },
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: "35px", md: "40px" },
                    fontWeight: 700,
                    fontFamily: "inherit",
                  }}
                >
                  Benefits
                </Typography>
                {/* <Typography variant="h1" sx={{letterSpacing:0.3,lineHeight:1.5,fontWeight:300,fontFamily:"inherit",fontSize:"20px",mt:"1rem"}}>A <span style={{color:commonCss.orange,fontWeight:600}}>Safety Walk</span> is a digital platform designed to streamline safety inspections, audits, and reporting processes in workplaces. It typically helps organizations ensure compliance with safety standards, identify hazards, and promote a safer environment.</Typography>
            
            <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Benefits</Typography> */}
                <List
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontFamily: "Roboto, sans-serif",
                      fontSize: "1.1rem",
                      fontWeight: 400,
                    },
                    display: "flex",
                    columnGap: "1rem",
                    flexWrap: "wrap",
                    width: "100%",
                    mt: 1,
                  }}
                >
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Enhanced user experience through intuitive navigation and
                      fast booking.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Real-time updates to prevent double bookings and maintain
                      accuracy.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Increased business visibility for service providers
                      through a centralized platform.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Reduced booking errors and improved customer satisfaction.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Interactive dashboards</ListItemText>
                  </ListItem>
                </List>
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2
            container
            justifyContent={"center"}
            sx={{ background: commonCss.backgroundGray }}
          >
            <Grid2
              container
              size={12}
              spacing={"1rem"}
              sx={{
                padding: { xs: "1.5rem", md: "2rem" },
                maxWidth: { xs: "auto", xl: "2000px" },
              }}
              alignItems={"center"}
            >
              <Grid2
                size={{ xs: 12, md: 6 }}
                sx={{
                  pl: {
                    xs: 0,
                    md: "3rem",
                    fontFamily: "Roboto, Arial, sans-serif",
                  },
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: "35px", md: "40px" },
                    fontWeight: 700,
                    fontFamily: "inherit",
                  }}
                >
                  Space Management Features
                </Typography>
                {/* <Typography variant="h1" sx={{letterSpacing:0.3,lineHeight:1.5,fontWeight:300,fontFamily:"inherit",fontSize:"20px",mt:"1rem"}}>A <span style={{color:commonCss.orange,fontWeight:600}}>Safety Walk</span> is a digital platform designed to streamline safety inspections, audits, and reporting processes in workplaces. It typically helps organizations ensure compliance with safety standards, identify hazards, and promote a safer environment.</Typography>
            
            <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Benefits</Typography> */}
                <List
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontFamily: "Roboto, sans-serif",
                      fontSize: "1.1rem",
                      fontWeight: 400,
                    },
                    display: "flex",
                    columnGap: "1rem",
                    flexWrap: "wrap",
                    width: "100%",
                    mt: 1,
                  }}
                >
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Space Allocation & Leasing.</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Space Utilization Analytics.</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Maintenance & Service Requests.</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Revenue and Payment Management.</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Tenant Communication Hub.</ListItemText>
                  </ListItem>
                </List>
              </Grid2>

              <Grid2
                container
                size={{ xs: 12, md: 6 }}
                justifyContent={{ xs: "center", md: "flex-end" }}
              >
                <img src={"/Images/IPB/image6.png"} alt="Internet Booking Platform screenshot" style={{ width: "85%", height: "100%" }} />
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2 container justifyContent={"center"}>
            <Grid2
              container
              size={12}
              spacing={"1rem"}
              sx={{
                padding: { xs: "1.5rem", md: "3rem 3rem 1rem 3rem" },
                maxWidth: { xs: "auto", md: "2000px" },
              }}
              alignItems={"center"}
            >
              <Grid2
                container
                size={{ xs: 12, md: 6 }}
                justifyContent={{ xs: "center", md: "flex-start" }}
              >
                <img src={"/Images/IPB/image2.png"} alt="Internet Booking Platform screenshot" style={{ width: "85%", height: "100%" }} />
              </Grid2>
              <Grid2
                size={{ xs: 12, md: 6 }}
                sx={{
                  pr: {
                    xs: 0,
                    md: "3rem",
                    fontFamily: "Roboto, Arial, sans-serif",
                  },
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: "35px", md: "40px" },
                    fontWeight: 700,
                    fontFamily: "inherit",
                  }}
                >
                  Advertisement Management Features
                </Typography>
                {/* <Typography variant="h1" sx={{letterSpacing:0.3,lineHeight:1.5,fontWeight:300,fontFamily:"inherit",fontSize:"20px",mt:"1rem"}}>A <span style={{color:commonCss.orange,fontWeight:600}}>Safety Walk</span> is a digital platform designed to streamline safety inspections, audits, and reporting processes in workplaces. It typically helps organizations ensure compliance with safety standards, identify hazards, and promote a safer environment.</Typography>
            
            <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Benefits</Typography> */}
                <List
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontFamily: "Roboto, sans-serif",
                      fontSize: "1.1rem",
                      fontWeight: 400,
                    },
                    display: "flex",
                    columnGap: "1rem",
                    flexWrap: "wrap",
                    width: "100%",
                    mt: 1,
                  }}
                >
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Ad Space Inventory Management.</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Ad Campaign Management.</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Advertising Analytics.</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Multi-Channel Ad Management.</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Advertiser Management</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Multi-Tenant Ad Management</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Ad Compliance & Approval Workflow
                    </ListItemText>
                  </ListItem>
                </List>
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2 size={12} container justifyContent={"flex-end"} sx={{p:"0rem 2rem 2rem 0rem",width:{xs:"auto",xl:"2000px"}}}>
                <Button
                        sx={{
                          backgroundColor: commonCss.buttonBg,
                          color: commonCss.buttonText,
                          padding: "0.5rem 2rem",
                          textTransform: "none",
                          width:"fit-content",
                          fontWeight: 500,
                          fontSize: "0.95rem",
                          borderRadius: "30px",
                          ":hover": {
                            background: commonCss.blue,
                          },
                           position: 'relative',
                            transition: '0.3s',
                              animation: 'glow 1.5s infinite alternate',
                          
                            '@keyframes glow': {
                              '0%': {
                                background: "#FCAE1E",
                              },
                              '100%': {
                                background: commonCss.blue,
                              },
                            },
                        }}
                        onClick={() => {
                          navigate("/contactus?type=Product Demo&&demo=Internet Booking Platform");
                        }}
                      >
                        Schedule a Demo
                      </Button>
                </Grid2>
        </Grid2>
        <Grid2 id="ptw" container size={12} justifyContent={"center"}>
          <Grid2 container size={12} justifyContent={"center"}>
            <Typography
              variant="h4"
              sx={{
                textAlign: { xs: "center", md: "left" },
                fontWeight: 500,
                color: commonCss.blue,
                fontSize: { xs: "2rem", md: "2.2rem" },
                mb: "2.5rem",
                // textShadow: '0 0 5px rgba(255, 255, 255, 0.8)'
              }}
            >
              Permit To Work
            </Typography>
          </Grid2>
          <Grid2 container justifyContent={"center"}>
            <Grid2
              container
              size={12}
              spacing={"1rem"}
              sx={{
                padding: { xs: "1.5rem", md: "0 3rem 3rem 3rem" },
                maxWidth: { xs: "auto", xl: "2000px" },
              }}
              alignItems={"center"}
            >
              <Grid2
                container
                size={{ xs: 12, md: 6 }}
                justifyContent={{ xs: "center", md: "flex-start" }}
              >
                <img
                  src={"/Images/PTW/dashboard.png"}
                  alt="Permit to Work dashboard"
                  style={{ width: "85%", height: "100%" }}
                />
              </Grid2>
              <Grid2
                size={{ xs: 12, md: 6 }}
                sx={{
                  pr: {
                    xs: 0,
                    md: "3rem",
                    fontFamily: "Roboto, Arial, sans-serif",
                  },
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: "35px", md: "40px" },
                    textAlign: { xs: "center", md: "left" },
                    fontWeight: 700,
                    fontFamily: "inherit",
                  }}
                >
                  Permit To Work Web App{" "}
                </Typography>
                <Typography
                  variant="h1"
                  sx={{
                    letterSpacing: 0.3,
                    lineHeight: 1.5,
                    fontWeight: 300,
                    fontFamily: "inherit",
                    fontSize: "20px",
                    mt: "1rem",
                  }}
                >
                  A{" "}
                  <span style={{ color: commonCss.orange, fontWeight: 600 }}>
                    e-PTW
                  </span>{" "}
                  Management Web App is a digital solution designed to
                  streamline and improve the process of managing work permits
                  within an organization, ensuring compliance with safety
                  regulations and industry standards. The app serves as a
                  centralized platform where users can create, track, and
                  approve permits for high-risk tasks, ensuring that safety
                  protocols are followed before, during, and after the work is
                  conducted.
                </Typography>

                <Typography
                  sx={{
                    fontSize: "1.1rem",
                    fontWeight: 700,
                    fontFamily: "inherit",
                    mt: 4,
                  }}
                >
                  Key Features
                </Typography>
                <List
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontFamily: "Roboto, sans-serif",
                      fontSize: "1rem",
                      fontWeight: 600,
                    },
                    display: "flex",
                    columnGap: "1rem",
                    flexWrap: "wrap",
                    width: "100%",
                    mt: 1,
                  }}
                >
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Permit Creation and Approval</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Real-Time Tracking and Notifications
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Risk Assessment Integration</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Automated Notifications</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Role-Based Access Control</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Audit Trails and Reporting</ListItemText>
                  </ListItem>
                </List>
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2
            container
            justifyContent={"center"}
            sx={{ background: commonCss.backgroundGray }}
          >
            <Grid2
              container
              size={12}
              spacing={"1rem"}
              sx={{
                padding: { xs: "1.5rem", md: "3rem" },
                maxWidth: { xs: "auto", md: "2000px" },
              }}
              alignItems={"center"}
            >
              <Grid2
                size={{ xs: 12, md: 6 }}
                sx={{
                  pl: {
                    xs: 0,
                    md: "3rem",
                    fontFamily: "Roboto, Arial, sans-serif",
                  },
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: "35px", md: "40px" },
                    fontWeight: 700,
                    fontFamily: "inherit",
                  }}
                >
                  A smart digital solution for managing and automating
                  permit-to-work processes efficiently and securely.
                </Typography>
                <Typography
                  variant="h1"
                  sx={{
                    letterSpacing: 0.3,
                    lineHeight: 1.5,
                    fontWeight: 300,
                    fontFamily: "inherit",
                    fontSize: "20px",
                    mt: "1rem",
                  }}
                >
                  Why Use e-PTW?
                </Typography>

                {/* <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Key Features</Typography> */}
                <List
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontFamily: "Roboto, sans-serif",
                      fontSize: "1rem",
                      fontWeight: 600,
                    },
                    display: "flex",
                    columnGap: "1rem",
                    flexWrap: "wrap",
                    width: "100%",
                    mt: 4,
                  }}
                >
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      To enhance workplace safety by ensuring proper
                      authorization for high-risk tasks.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      To streamline and digitize the traditional paper-based
                      permit system for improved efficiency.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      To maintain clear accountability with a detailed audit
                      trail for compliance purposes.
                    </ListItemText>
                  </ListItem>
                </List>
              </Grid2>
              <Grid2
                container
                size={{ xs: 12, md: 6 }}
                justifyContent={{ xs: "center", md: "flex-end" }}
              >
                <img
                  src={"/Images/PTW/formlist.png"}
                  alt="Permit to Work form list"
                  style={{ width: "85%", height: "100%" }}
                />
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2 container justifyContent={"center"}>
            <Grid2
              container
              size={12}
              spacing={"1rem"}
              sx={{
                padding: { xs: "1.5rem", md: "3rem 3rem 1rem 3rem" },
                maxWidth: { xs: "auto", xl: "2000px" },
              }}
              alignItems={"center"}
            >
              <Grid2
                container
                size={{ xs: 12, md: 6 }}
                justifyContent={{ xs: "center", md: "flex-start" }}
              >
                <img
                  src={"/Images/PTW/formpage.png"}
                  alt="Permit to Work form page"
                  style={{ width: "85%", height: "100%" }}
                />
              </Grid2>
              <Grid2
                size={{ xs: 12, md: 6 }}
                sx={{
                  pr: {
                    xs: 0,
                    md: "3rem",
                    fontFamily: "Roboto, Arial, sans-serif",
                  },
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: "35px", md: "40px" },
                    fontWeight: 700,
                    fontFamily: "inherit",
                  }}
                >
                  Benefits
                </Typography>
                {/* <Typography variant="h1" sx={{letterSpacing:0.3,lineHeight:1.5,fontWeight:300,fontFamily:"inherit",fontSize:"20px",mt:"1rem"}}>A <span style={{color:commonCss.orange,fontWeight:600}}>Safety Walk</span> is a digital platform designed to streamline safety inspections, audits, and reporting processes in workplaces. It typically helps organizations ensure compliance with safety standards, identify hazards, and promote a safer environment.</Typography>
                     
                     <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Benefits</Typography> */}
                <List
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontFamily: "Roboto, sans-serif",
                      fontSize: "1.1rem",
                      fontWeight: 400,
                    },
                    display: "flex",
                    columnGap: "1rem",
                    flexWrap: "wrap",
                    width: "100%",
                    mt: 1,
                  }}
                >
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Ensures all safety protocols are followed by automating
                      checks and approvals.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Reduces manual paperwork and speeds up permit approvals.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Provides real-time insights into ongoing work permits
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Improves team communication with task tracking and alerts.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Safely stores all permit records for easy access and
                      audits.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Interactive dashboards </ListItemText>
                  </ListItem>
                </List>
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2 size={12} container justifyContent={"flex-end"} sx={{p:"0rem 2rem 2rem 0rem",width:{xs:"auto",xl:"2000px"}}}>
                <Button
                        sx={{
                          backgroundColor: commonCss.buttonBg,
                          color: commonCss.buttonText,
                          padding: "0.5rem 2rem",
                          textTransform: "none",
                          width:"fit-content",
                          fontWeight: 500,
                          fontSize: "0.95rem",
                          borderRadius: "30px",
                          ":hover": {
                            background: commonCss.blue,
                          },
                           position: 'relative',
                            transition: '0.3s',
                              animation: 'glow 1.5s infinite alternate',
                          
                            '@keyframes glow': {
                              '0%': {
                                background: "#FCAE1E",
                              },
                              '100%': {
                                background: commonCss.blue,
                              },
                            },
                        }}
                        onClick={() => {
                          navigate("/contactus?type=Product Demo&&demo=Permit To Work");
                        }}
                      >
                        Schedule a Demo
                      </Button>
                </Grid2>
        </Grid2>
        <Grid2 id="safetywalk" container size={12} justifyContent={"center"}>
          <Grid2 container size={12} justifyContent={"center"}>
            <Typography
              variant="h4"
              sx={{
                textAlign: { xs: "center", md: "left" },
                fontWeight: 500,
                color: commonCss.blue,
                fontSize: { xs: "2rem", md: "2.2rem" },
                mb: "2.5rem",
                // textShadow: '0 0 5px rgba(255, 255, 255, 0.8)'
              }}
            >
              Safety Walk
            </Typography>
          </Grid2>
          <Grid2 container justifyContent={"center"}>
            <Grid2
              container
              size={12}
              spacing={"1rem"}
              sx={{
                padding: { xs: "1.5rem", md: "0 3rem 3rem 3rem" },
                maxWidth: { xs: "auto", xl: "2000px" },
              }}
              alignItems={"center"}
            >
              <Grid2
                container
                size={{ xs: 12, md: 6 }}
                justifyContent={{ xs: "center", md: "flex-start" }}
              >
                <img
                  src={"/Images/safetyWalk/dashboard.png"}
                  alt="Safety Walk dashboard"
                  style={{ width: "85%", height: "100%" }}
                />
              </Grid2>
              <Grid2
                size={{ xs: 12, md: 6 }}
                sx={{
                  pr: {
                    xs: 0,
                    md: "3rem",
                    fontFamily: "Roboto, Arial, sans-serif",
                  },
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: "35px", md: "40px" },
                    textAlign: { xs: "center", md: "left" },
                    fontWeight: 700,
                    fontFamily: "inherit",
                  }}
                >
                  Industrial Safety Walk Web App & Mobile App
                </Typography>
                <Typography
                  variant="h1"
                  sx={{
                    letterSpacing: 0.3,
                    lineHeight: 1.5,
                    fontWeight: 300,
                    fontFamily: "inherit",
                    fontSize: "20px",
                    mt: "1rem",
                  }}
                >
                  A{" "}
                  <span style={{ color: commonCss.orange, fontWeight: 600 }}>
                    Safety Walk
                  </span>{" "}
                  is a digital platform designed to streamline safety
                  inspections, audits, and reporting processes in workplaces. It
                  typically helps organizations ensure compliance with safety
                  standards, identify hazards, and promote a safer environment.
                </Typography>

                <Typography
                  sx={{
                    fontSize: "1.1rem",
                    fontWeight: 700,
                    fontFamily: "inherit",
                    mt: 4,
                  }}
                >
                  Key Features
                </Typography>
                <List
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontFamily: "Roboto, sans-serif",
                      fontSize: "1rem",
                      fontWeight: 600,
                    },
                    display: "flex",
                    columnGap: "1rem",
                    flexWrap: "wrap",
                    width: "100%",
                    mt: 1,
                  }}
                >
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Inspection & Audits</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Incident Reporting</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Checklists & Guidelines</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Data Tracking & Analytics</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Corrective Actions</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Compliance Management</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Employee Engagement</ListItemText>
                  </ListItem>
                </List>
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2
            container
            justifyContent={"center"}
            sx={{ background: commonCss.backgroundGray }}
          >
            <Grid2
              container
              size={12}
              spacing={"1rem"}
              sx={{
                padding: { xs: "1.5rem", md: "3rem" },
                maxWidth: { xs: "auto", md: "2000px" },
              }}
              alignItems={"center"}
            >
              <Grid2
                size={{ xs: 12, md: 6 }}
                sx={{
                  pl: {
                    xs: 0,
                    md: "3rem",
                    fontFamily: "Roboto, Arial, sans-serif",
                  },
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: "35px", md: "40px" },
                    fontWeight: 700,
                    fontFamily: "inherit",
                  }}
                >
                  Are you struggling with registering your safety findings and
                  resolving the issue efficiently?
                </Typography>
                <Typography
                  variant="h1"
                  sx={{
                    letterSpacing: 0.3,
                    lineHeight: 1.5,
                    fontWeight: 300,
                    fontFamily: "inherit",
                    fontSize: "20px",
                    mt: "1rem",
                  }}
                >
                  Look no further than our Safety Walk solution.
                </Typography>

                {/* <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Key Features</Typography> */}
                <List
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontFamily: "Roboto, sans-serif",
                      fontSize: "1rem",
                      fontWeight: 600,
                    },
                    display: "flex",
                    columnGap: "1rem",
                    flexWrap: "wrap",
                    width: "100%",
                    mt: 4,
                  }}
                >
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Ability to report safety findings digitally
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Digitally route for multiple approvals
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Ability to attach images of the findings
                    </ListItemText>
                  </ListItem>
                </List>
              </Grid2>
              <Grid2
                container
                size={{ xs: 12, md: 6 }}
                justifyContent={{ xs: "center", md: "flex-end" }}
              >
                <img
                  src={"/Images/safetyWalk/formlist.png"}
                  alt="Safety Walk form list"
                  style={{ width: "85%", height: "100%" }}
                />
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2 container justifyContent={"center"}>
            <Grid2
              container
              size={12}
              spacing={"1rem"}
              sx={{
                padding: { xs: "1.5rem", md: "3rem 3rem 1rem 3rem" },
                maxWidth: { xs: "auto", xl: "2000px" },
              }}
              alignItems={"center"}
            >
              <Grid2
                container
                size={{ xs: 12, md: 6 }}
                justifyContent={{ xs: "center", md: "flex-start" }}
              >
                <img
                  src={"/Images/safetyWalk/formpage.png"}
                  alt="Safety Walk form page"
                  style={{ width: "85%", height: "100%" }}
                />
              </Grid2>
              <Grid2
                size={{ xs: 12, md: 6 }}
                sx={{
                  pr: {
                    xs: 0,
                    md: "3rem",
                    fontFamily: "Roboto, Arial, sans-serif",
                  },
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: "35px", md: "40px" },
                    fontWeight: 700,
                    fontFamily: "inherit",
                  }}
                >
                  Benefits
                </Typography>
                {/* <Typography variant="h1" sx={{letterSpacing:0.3,lineHeight:1.5,fontWeight:300,fontFamily:"inherit",fontSize:"20px",mt:"1rem"}}>A <span style={{color:commonCss.orange,fontWeight:600}}>Safety Walk</span> is a digital platform designed to streamline safety inspections, audits, and reporting processes in workplaces. It typically helps organizations ensure compliance with safety standards, identify hazards, and promote a safer environment.</Typography>
                  
                  <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Benefits</Typography> */}
                <List
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontFamily: "Roboto, sans-serif",
                      fontSize: "1.1rem",
                      fontWeight: 400,
                    },
                    display: "flex",
                    columnGap: "1rem",
                    flexWrap: "wrap",
                    width: "100%",
                    mt: 1,
                  }}
                >
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Enhances workplace safety and compliance.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Streamlines data collection and reporting.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Reduces paperwork with digital records.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Improves team communication with task tracking and alerts.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Access to historical safety e-Forms
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Interactive dashboards & KPIs</ListItemText>
                  </ListItem>
                </List>
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2 size={12} container justifyContent={"flex-end"} sx={{p:"0rem 2rem 2rem 0rem",width:{xs:"auto",xl:"2000px"}}}>
                <Button
                        sx={{
                          backgroundColor: commonCss.buttonBg,
                          color: commonCss.buttonText,
                          padding: "0.5rem 2rem",
                          textTransform: "none",
                          width:"fit-content",
                          fontWeight: 500,
                          fontSize: "0.95rem",
                          borderRadius: "30px",
                          ":hover": {
                            background: commonCss.blue,
                          },
                           position: 'relative',
                            transition: '0.3s',
                              animation: 'glow 1.5s infinite alternate',
                          
                            '@keyframes glow': {
                              '0%': {
                                background: "#FCAE1E",
                              },
                              '100%': {
                                background: commonCss.blue,
                              },
                            },
                        }}
                        onClick={() => {
                          navigate("/contactus?type=Product Demo&&demo=Safety Walk");
                        }}
                      >
                        Schedule a Demo
                      </Button>
                </Grid2>
        </Grid2>
        <Grid2 id="e-form" container size={12} justifyContent={"center"}>
          <Grid2 container size={12} justifyContent={"center"}>
            <Typography
              variant="h4"
              sx={{
                textAlign: { xs: "center", md: "left" },
                fontWeight: 500,
                color: commonCss.blue,
                fontSize: { xs: "2rem", md: "2.2rem" },
                mb: "2.5rem",
                // textShadow: '0 0 5px rgba(255, 255, 255, 0.8)'
              }}
            >
              Secuity e-Form
            </Typography>
          </Grid2>
          <Grid2 container justifyContent={"center"}>
            <Grid2
              container
              size={12}
              spacing={"1rem"}
              sx={{
                padding: { xs: "1.5rem", md: "0 3rem 3rem 3rem" },
                maxWidth: { xs: "auto", xl: "2000px" },
              }}
              alignItems={"center"}
            >
              <Grid2
                container
                size={{ xs: 12, md: 6 }}
                justifyContent={{ xs: "center", md: "flex-start" }}
              >
                <img
                  src={"/Images/e-Form/dashboard.png"}
                  alt="Security e-Form dashboard"
                  style={{ width: "85%", height: "100%" }}
                />
              </Grid2>
              <Grid2
                size={{ xs: 12, md: 6 }}
                sx={{
                  pr: {
                    xs: 0,
                    md: "3rem",
                    fontFamily: "Roboto, Arial, sans-serif",
                  },
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: "35px", md: "40px" },
                    textAlign: { xs: "center", md: "left" },
                    fontWeight: 700,
                    fontFamily: "inherit",
                  }}
                >
                  Secuity e-Form Web App
                </Typography>
                <Typography
                  variant="h1"
                  sx={{
                    letterSpacing: 0.3,
                    lineHeight: 1.5,
                    fontWeight: 300,
                    fontFamily: "inherit",
                    fontSize: "20px",
                    mt: "1rem",
                  }}
                >
                  A{" "}
                  <span style={{ color: commonCss.orange, fontWeight: 600 }}>
                    Security E-Form
                  </span>{" "}
                  is a digital solution designed to streamline security-related
                  documentation, ensuring accurate data collection, improved
                  record management, and enhanced security protocols. This
                  platform enables users to submit, manage, and review security
                  forms efficiently through a web interface.
                </Typography>

                <Typography
                  sx={{
                    fontSize: "1.1rem",
                    fontWeight: 700,
                    fontFamily: "inherit",
                    mt: 4,
                  }}
                >
                  Key Features
                </Typography>
                <List
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontFamily: "Roboto, sans-serif",
                      fontSize: "1rem",
                      fontWeight: 600,
                    },
                    display: "flex",
                    columnGap: "1rem",
                    flexWrap: "wrap",
                    width: "100%",
                    mt: 1,
                  }}
                >
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Digital Form Submission</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Data Validation</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Secure Access Control</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Audit Logs</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Employee Engagement</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>File Upload Support</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Analytics & Reporting</ListItemText>
                  </ListItem>
                </List>
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2
            container
            justifyContent={"center"}
            sx={{ background: commonCss.backgroundGray }}
          >
            <Grid2
              container
              size={12}
              spacing={"1rem"}
              sx={{
                padding: { xs: "1.5rem", md: "3rem" },
                maxWidth: { xs: "auto", md: "2000px" },
              }}
              alignItems={"center"}
            >
              <Grid2
                size={{ xs: 12, md: 6 }}
                sx={{
                  pl: {
                    xs: 0,
                    md: "3rem",
                    fontFamily: "Roboto, Arial, sans-serif",
                  },
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: "35px", md: "40px" },
                    fontWeight: 700,
                    fontFamily: "inherit",
                  }}
                >
                  A user-friendly platform that enhances security workflows with
                  digital form submission, real-time tracking, and secure data
                  storage.
                </Typography>
                <Typography
                  variant="h1"
                  sx={{
                    letterSpacing: 0.3,
                    lineHeight: 1.5,
                    fontWeight: 300,
                    fontFamily: "inherit",
                    fontSize: "20px",
                    mt: "1rem",
                  }}
                >
                  Look no further than our Secuity e-Form solution.
                </Typography>

                {/* <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Key Features</Typography> */}
                <List
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontFamily: "Roboto, sans-serif",
                      fontSize: "1rem",
                      fontWeight: 600,
                    },
                    display: "flex",
                    columnGap: "1rem",
                    flexWrap: "wrap",
                    width: "100%",
                    mt: 4,
                  }}
                >
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Ability to digital solution for reporting & tracking
                      security findings.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Digitally route reports for multi-level approvals
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Streamlined incident management for quick reporting and
                      resolution.
                    </ListItemText>
                  </ListItem>
                </List>
              </Grid2>
              <Grid2
                container
                size={{ xs: 12, md: 6 }}
                justifyContent={{ xs: "center", md: "flex-end" }}
              >
                <img
                  src={"/Images/e-Form/form.png"}
                  alt="Security e-Form form screen"
                  style={{ width: "85%", height: "100%" }}
                />
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2 container justifyContent={"center"}>
            <Grid2
              container
              size={12}
              spacing={"1rem"}
              sx={{
                padding: { xs: "1.5rem", md: "3rem 3rem 1rem 3rem" },
                maxWidth: { xs: "auto", xl: "2000px" },
              }}
              alignItems={"center"}
            >
              <Grid2
                container
                size={{ xs: 12, md: 6 }}
                justifyContent={{ xs: "center", md: "flex-start" }}
              >
                <img src={"/Images/e-Form/suppliers.png"} alt="Security e-Form suppliers screen" style={{ width: "85%", height: "100%" }} />
              </Grid2>
              <Grid2
                size={{ xs: 12, md: 6 }}
                sx={{
                  pr: {
                    xs: 0,
                    md: "3rem",
                    fontFamily: "Roboto, Arial, sans-serif",
                  },
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: "35px", md: "40px" },
                    fontWeight: 700,
                    fontFamily: "inherit",
                  }}
                >
                  Benefits
                </Typography>
                {/* <Typography variant="h1" sx={{letterSpacing:0.3,lineHeight:1.5,fontWeight:300,fontFamily:"inherit",fontSize:"20px",mt:"1rem"}}>A <span style={{color:commonCss.orange,fontWeight:600}}>Safety Walk</span> is a digital platform designed to streamline safety inspections, audits, and reporting processes in workplaces. It typically helps organizations ensure compliance with safety standards, identify hazards, and promote a safer environment.</Typography>
            
            <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Benefits</Typography> */}
                <List
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontFamily: "Roboto, sans-serif",
                      fontSize: "1.1rem",
                      fontWeight: 400,
                    },
                    display: "flex",
                    columnGap: "1rem",
                    flexWrap: "wrap",
                    width: "100%",
                    mt: 1,
                  }}
                >
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Allows image attachments for clear evidence and detailed
                      reporting.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Enables users to submit and review forms from any device,
                      anytime.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      racks submissions, approvals, and updates for improved
                      transparency.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Improves team communication with task tracking and alerts.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Digital forms with validation reduce errors and ensure
                      complete information.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Ensures sensitive information is protected with role-based
                      access control.
                    </ListItemText>
                  </ListItem>
                </List>
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2 size={12} container justifyContent={"flex-end"} sx={{p:"0rem 2rem 2rem 0rem",width:{xs:"auto",xl:"2000px"}}}>
                <Button
                        sx={{
                          backgroundColor: commonCss.buttonBg,
                          color: commonCss.buttonText,
                          padding: "0.5rem 2rem",
                          textTransform: "none",
                          width:"fit-content",
                          fontWeight: 500,
                          fontSize: "0.95rem",
                          borderRadius: "30px",
                          ":hover": {
                            background: commonCss.blue,
                          },
                           position: 'relative',
                            transition: '0.3s',
                              animation: 'glow 1.5s infinite alternate',
                          
                            '@keyframes glow': {
                              '0%': {
                                background: "#FCAE1E",
                              },
                              '100%': {
                                background: commonCss.blue,
                              },
                            },
                        }}
                        onClick={() => {
                          navigate("/contactus?type=Product Demo&&demo=Security e-Form");
                        }}
                      >
                        Schedule a Demo
                      </Button>
                </Grid2>
        </Grid2>
        <Grid2 container id="ojt" size={12} justifyContent={"center"}>
          <Grid2 container size={12} justifyContent={"center"}>
            <Typography
              variant="h4"
              sx={{
                textAlign: { xs: "center", md: "left" },
                fontWeight: 500,
                color: commonCss.blue,
                fontSize: { xs: "2rem", md: "2.2rem" },
                mb: "2.5rem",
                // textShadow: '0 0 5px rgba(255, 255, 255, 0.8)'
              }}
            >
              Online Job Training
            </Typography>
          </Grid2>
          <Grid2 container justifyContent={"center"}>
            <Grid2
              container
              size={12}
              spacing={"1rem"}
              sx={{
                padding: { xs: "1.5rem", md: "0 3rem 3rem 3rem" },
                maxWidth: { xs: "auto", xl: "2000px" },
              }}
              alignItems={"center"}
            >
              <Grid2
                container
                size={{ xs: 12, md: 6 }}
                justifyContent={{ xs: "center", md: "flex-start" }}
              >
                <img
                  src={"/Images/OJT/dashboard.png"}
                  alt="OJT dashboard"
                  style={{ width: "85%", height: "100%" }}
                />
              </Grid2>
              <Grid2
                size={{ xs: 12, md: 6 }}
                sx={{
                  pr: {
                    xs: 0,
                    md: "3rem",
                    fontFamily: "Roboto, Arial, sans-serif",
                  },
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: "35px", md: "40px" },
                    textAlign: { xs: "center", md: "left" },
                    fontWeight: 700,
                    fontFamily: "inherit",
                  }}
                >
                  Job Training Management Web App
                </Typography>
                <Typography
                  variant="h1"
                  sx={{
                    letterSpacing: 0.3,
                    lineHeight: 1.5,
                    fontWeight: 300,
                    fontFamily: "inherit",
                    fontSize: "20px",
                    mt: "1rem",
                  }}
                >
                  A{" "}
                  <span style={{ color: commonCss.orange, fontWeight: 600 }}>
                    OJT
                  </span>{" "}
                  is a comprehensive platform designed to facilitate the
                  seamless management of employee training programs. The app
                  allows organizations to plan, track, and evaluate the
                  effectiveness of training sessions, helping employees build
                  the necessary skills to perform their jobs efficiently.{" "}
                </Typography>

                <Typography
                  sx={{
                    fontSize: "1.1rem",
                    fontWeight: 700,
                    fontFamily: "inherit",
                    mt: 4,
                  }}
                >
                  Key Features
                </Typography>
                <List
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontFamily: "Roboto, sans-serif",
                      fontSize: "1rem",
                      fontWeight: 600,
                    },
                    display: "flex",
                    columnGap: "1rem",
                    flexWrap: "wrap",
                    width: "100%",
                    mt: 1,
                  }}
                >
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Training Program Scheduling</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Course Creation and Cataloging</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Employee Progress Tracking</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Resource Management</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Automated Reminders and Notifications
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Customizable Dashboards</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>User Management</ListItemText>
                  </ListItem>
                </List>
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2
            container
            justifyContent={"center"}
            sx={{ background: commonCss.backgroundGray }}
          >
            <Grid2
              container
              size={12}
              spacing={"1rem"}
              sx={{
                padding: { xs: "1.5rem", md: "3rem" },
                maxWidth: { xs: "auto", md: "2000px" },
              }}
              alignItems={"center"}
            >
              <Grid2
                size={{ xs: 12, md: 6 }}
                sx={{
                  pl: {
                    xs: 0,
                    md: "3rem",
                    fontFamily: "Roboto, Arial, sans-serif",
                  },
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: "35px", md: "40px" },
                    fontWeight: 700,
                    fontFamily: "inherit",
                  }}
                >
                  It enables administrators to plan, organize, track, and
                  evaluate training sessions efficiently, while also providing
                  employees with easy access to training schedules, progress
                  tracking, and certification management.
                </Typography>
                <Typography
                  variant="h1"
                  sx={{
                    letterSpacing: 0.3,
                    lineHeight: 1.5,
                    fontWeight: 300,
                    fontFamily: "inherit",
                    fontSize: "20px",
                    mt: "1rem",
                  }}
                >
                  Why Use OJT?
                </Typography>

                {/* <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Key Features</Typography> */}
                <List
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontFamily: "Roboto, sans-serif",
                      fontSize: "1rem",
                      fontWeight: 600,
                    },
                    display: "flex",
                    columnGap: "1rem",
                    flexWrap: "wrap",
                    width: "100%",
                    mt: 4,
                  }}
                >
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Employees learn by doing, gaining hands-on experience.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Tailored to the specific needs of the job and
                      organization.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      {" "}
                      Real-world practice reinforces skills and boosts
                      confidence.
                    </ListItemText>
                  </ListItem>
                </List>
              </Grid2>
              <Grid2
                container
                size={{ xs: 12, md: 6 }}
                justifyContent={{ xs: "center", md: "flex-end" }}
              >
                <img
                  src={"/Images/OJT/userTraining.png"}
                  alt="OJT user training screen"
                  style={{ width: "85%", height: "100%" }}
                />
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2 container justifyContent={"center"}>
            <Grid2
              container
              size={12}
              spacing={"1rem"}
              sx={{
                padding: { xs: "1.5rem", md: "3rem 3rem 1rem 3rem" },
                maxWidth: { xs: "auto", xl: "2000px" },
              }}
              alignItems={"center"}
            >
              <Grid2
                container
                size={{ xs: 12, md: 6 }}
                justifyContent={{ xs: "center", md: "flex-start" }}
              >
                <img
                  src={"/Images/OJT/trainerTraining.png"}
                  alt="OJT trainer training screen"
                  style={{ width: "85%", height: "100%" }}
                />
              </Grid2>
              <Grid2
                size={{ xs: 12, md: 6 }}
                sx={{
                  pr: {
                    xs: 0,
                    md: "3rem",
                    fontFamily: "Roboto, Arial, sans-serif",
                  },
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: "35px", md: "40px" },
                    fontWeight: 700,
                    fontFamily: "inherit",
                  }}
                >
                  Benefits
                </Typography>
                {/* <Typography variant="h1" sx={{letterSpacing:0.3,lineHeight:1.5,fontWeight:300,fontFamily:"inherit",fontSize:"20px",mt:"1rem"}}>A <span style={{color:commonCss.orange,fontWeight:600}}>Safety Walk</span> is a digital platform designed to streamline safety inspections, audits, and reporting processes in workplaces. It typically helps organizations ensure compliance with safety standards, identify hazards, and promote a safer environment.</Typography>
                 
                 <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Benefits</Typography> */}
                <List
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontFamily: "Roboto, sans-serif",
                      fontSize: "1.1rem",
                      fontWeight: 400,
                    },
                    display: "flex",
                    columnGap: "1rem",
                    flexWrap: "wrap",
                    width: "100%",
                    mt: 1,
                  }}
                >
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Centralized training management for better organization.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Real-time tracking and analytics to monitor progress.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Streamlined communication through notifications and
                      alerts.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Comprehensive reporting for performance evaluation.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>
                      Reminders for upcoming training sessions and deadlines.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <ListItemIcon>
                      <Done />
                    </ListItemIcon>
                    <ListItemText>Interactive dashboards</ListItemText>
                  </ListItem>
                </List>
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2 size={12} container justifyContent={"flex-end"} sx={{p:"0rem 2rem 2rem 0rem",width:{xs:"auto",xl:"2000px"}}}>
                <Button
                        sx={{
                          backgroundColor: commonCss.buttonBg,
                          color: commonCss.buttonText,
                          padding: "0.5rem 2rem",
                          textTransform: "none",
                          width:"fit-content",
                          fontWeight: 500,
                          fontSize: "0.95rem",
                          borderRadius: "30px",
                          ":hover": {
                            background: commonCss.blue,
                          },
                           position: 'relative',
                            transition: '0.3s',
                              animation: 'glow 1.5s infinite alternate',
                          
                            '@keyframes glow': {
                              '0%': {
                                background: "#FCAE1E",
                              },
                              '100%': {
                                background: commonCss.blue,
                              },
                            },
                        }}
                        onClick={() => {
                          navigate("/contactus?type=Product Demo&&demo=Online Job Training");
                        }}
                      >
                        Schedule a Demo
                      </Button>
                </Grid2>
        </Grid2>
      </Grid2>
    </Grid2>
  );
};

export default CommonPage;
